import React from "react";
import { NavLink } from "react-router-dom";
import Login from "../components/client/auth/Login/Login";
import NotificationDropdown from "../components/client/NotificationDropdown/NotificationDropdown";
import ProfileDropdown from "../components/client/ProfileDropdown/ProfileDropdown";

export default function CarrerHeader() {
  return (
    <>
      <header
        className='header dashboard-header'
      >
        <nav className="navbar navbar-expand-xl navbar-dark container">
          <NavLink className="navbar-brand d-flex align-items-center" to="/">
            <img src="/image/dlogo.png " alt="Logo" />
          </NavLink>

          <div className="collapse navbar-collapse" id="navbarNavDropdown">
            <ul className="navbar-nav me-auto ">
              <li className="nav-item">
                <NavLink className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} to="/loads">
                  Loads
                </NavLink>
              </li>
              <li className="nav-item ">
                <NavLink className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} to="/bids">
                  My Bids
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} to="/fleet">
                  Fleet
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} to="/drivers">
                  Drivers
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} to="/review">
                  Reviews
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} to="/message">
                  Messages
                </NavLink>
              </li>
            </ul>
          </div>
          <div className="d-flex align-items-center gap-4 text-white">

            <NavLink className={({ isActive }) => isActive ? "nav-link text-dark active" : "nav-link text-dark"} to="/carrer-dashboard">
              Dashboard
            </NavLink>

            <div className="align-items-center gap-3 d-flex">
              <NotificationDropdown />
              <ProfileDropdown />
            </div>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNavDropdown"
              aria-controls="navbarNavDropdown"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon" />
            </button>


          </div>
        </nav>

      </header>
      <Login />
    </>
  );
}
